import { render, staticRenderFns } from "./gridTela.vue?vue&type=template&id=310bd0d9&scoped=true&"
import script from "./gridTela.vue?vue&type=script&lang=js&"
export * from "./gridTela.vue?vue&type=script&lang=js&"
import style0 from "./gridTela.vue?vue&type=style&index=0&id=310bd0d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310bd0d9",
  null
  
)

export default component.exports